import styled from 'styled-components';
import {
  Container as RawContainer,
  size,
  Col,
  mediaQueries,
} from '@everlywell/leaves';
import Img from 'gatsby-image';
import { SectionTitle as RawSectionTitle } from '../../Enterprise/SectionTitle';

const Container = styled(RawContainer)`
  padding-top: ${size.xl4}px;
  padding-bottom: ${size.xl4}px;
`;

const SectionTitle = styled(RawSectionTitle)`
  margin-bottom: ${size.xl1}px;
  text-align: center;
`;

const LogoContainer = styled(Col)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const ImageWrapper = styled.div`
  flex: 0 0 50%;
  display: flex;
  margin-bottom: ${size.lg}px;
  ${mediaQueries.forTabletVerticalUp} {
    flex: 0 0 33%;
  }
  ${mediaQueries.forDesktopUp} {
    flex: 0 0 15%;
  }
`;

const GatsbyImg = styled(Img)`
  width: 100%;
  height: 22px;
  ${mediaQueries.forDesktopUp} {
    height: 32px;
  }
`;

export { Container, SectionTitle, ImageWrapper, LogoContainer, GatsbyImg };
